export const hasNoBusinessData = <T extends object>(obj?: T): boolean => {
	if (obj == null) return true;

	const ignoreKeys = [
		"type",
		"id",
		"title",
		"name",
		"createdAt",
		"updatedAt",
		"related",
	];

	return Object.keys(obj).every((key) => {
		if (ignoreKeys.includes(key)) return true;

		const value = obj[key as keyof T];

		if (value === null || value === undefined) return true;
		if (Array.isArray(value)) return value.length === 0;
		if (typeof value === "boolean") return value === false;
		if (typeof value === "number") return value === 0;
		if (typeof value === "string") {
			const string = value.trim().toLowerCase();
			return (
				string === "" ||
				string === "none" ||
				string === "empty" ||
				string === "null" ||
				string === "0"
			);
		}

		return false;
	});
};
